import AcademyEditor from '@academy/editor';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface IWorkbookState {
  loading: boolean;
  workbookEditor: AcademyEditor | null;
}

const workbookSlice = createSliceSteamup(
  'workbook',
  {
    loading: true,
    workbookEditor: null,
  } as IWorkbookState,
  {
    init(state, { payload }: PayloadAction<AcademyEditor>) {
      return {
        ...state,
        workbookEditor: payload,
      };
    },
    destroy(state) {
      return {
        ...state,
        workbookEditor: null,
      };
    },
  },
);

export default workbookSlice;
